import React, { useContext } from 'react';
import { PageStateContext } from '../../services';
import { AnyProps } from '../types';

export const RocheTooltip = ({ blok }: AnyProps): JSX.Element => React.createElement('roche-tooltip', {
  icon: blok.icon,
  text: blok.text,
  title: blok.title,
  // eslint-disable-next-line no-underscore-dangle
  uid: blok._uid,
});

/**
 * Replace the [tooltip=tooltip-title] expressions in a string with the
 * JSX tag
 * @param {string} code The string to process
 * @return {string} The processed string
 */
export const InjectRocheTooltip = (code = ''): string => {
  const pageContext = useContext(PageStateContext);

  const tooltipRegExp = /\[[\s]*tooltip=[\s]*([^\][]+)[\s]*\]/g;
  let replacedCode = code;
  const tooltipMatches = [];
  let m = null;

  do {
    m = tooltipRegExp.exec(code);
    if (m) {
      tooltipMatches.push(m);
    }
  } while (m);

  tooltipMatches.forEach((match) => {
    const data = pageContext?.page.content?.tooltips?.find((tooltip) => tooltip.title === match[1]);
    if (data) {
      const replaceText = `<roche-tooltip icon="information-inverted" title="${data.title}" text="${data.text}"></roche-tooltip>`;
      replacedCode = replacedCode.replace(match[0], replaceText);
    } else {
      replacedCode = replacedCode.replace(match[0], '');
    }
  });

  return replacedCode;
};
